import EditEmployeeDataModal from './EditEmployeeDataModal'

export default EditEmployeeDataModal
